import Avatar from "antd/lib/avatar/avatar";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  getAllNotifications,
  updateAllNotifications,
} from "../../redux/actions/notificationAction";
import { Menu, Dropdown } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import dayOfYear from "dayjs/plugin/dayOfYear";
dayjs.extend(dayOfYear);
dayjs.extend(relativeTime);

const NotificationMiniView = (props) => {
  const history = useHistory();
  const renderListView = (listSource) => {
    let list = [];

    listSource.forEach((item, index) => {
      let name = "";
      if (item.sender) {
        name += item.sender["firstName"] ? item.sender["firstName"][0] : "";
        name += item.sender["lastName"] ? item.sender["lastName"][0] : "";
      }
      list.push(
        <div
          key={index}
          onClick={() => {
            if (item?.blogPost?.urlSlug) {
              history.push(`/viewpost/${item?.blogPost?.urlSlug}`);
            } else if (item?.blog?.urlSlug) {
              history.push(`/blogfolio/${item?.blog?.urlSlug}/about`);
            }
          }}
          style={{
            cursor:
              item?.blogPost?.urlSlug || item?.blog?.urlSlug
                ? "pointer"
                : "default",
          }}
        >
          <div
            style={{
              background: item.isRead ? "#fff" : "#faf8f8",
            }}
            className="d-flex notif-list-item1"
          >
            <Avatar
              shape="circle"
              icon={name}
              src={item.sender?.profileImage}
              alt=""
              className="mr-3"
              style={{
                height: "72px",
                width: "72px",
                lineHeight: "72px",
                fontSize: "36px",
              }}
            />
            <div style={{ maxWidth: "70%" }}>
              <p className="notif-text mb-0 text-truncate ">
                {item?.sender?.role === "user" ? (
                  <b>
                    {`${item.sender?.firstName} ${item.sender?.lastName ?? ""}`}
                  </b>
                ) : (
                  <b>
                    Dr.
                    {` ${item.sender?.firstName} ${
                      item.sender?.lastName ? item.sender?.lastName : ""
                    }`}
                  </b>
                )}
              </p>
              <p>{`${item.message}`}</p>
              <p className="notif-text-small mb-0 text-truncate ">{`${
                item.createdAt ? dayjs(item.createdAt).fromNow() : ""
              }`}</p>
            </div>
          </div>
        </div>
      );
    });
    return list;
  };
  console.log(props);
  let todaysNotifs = [];
  let earlierNotifs = [];
  if (props.notifications.length > 0) {
    todaysNotifs = props.notifications.filter(
      (x) => dayjs(x.createdAt).dayOfYear() === dayjs().dayOfYear()
    );
    earlierNotifs = props.notifications.filter(
      (x) => dayjs(x.createdAt).dayOfYear() !== dayjs().dayOfYear()
    );
  }

  const handleActions = ({ domEvent, key }) => {
    domEvent.stopPropagation();
    console.log("all read");
    if (key === "all") {
      props.updateAllNotifications({
        markAllRead: true,
      });
    }
  };

  const menu = (
    <Menu onClick={handleActions}>
      <Menu.Item key="all">Mark all as read.</Menu.Item>
    </Menu>
  );

  return (
    <React.Fragment>
      <div className="notification-mini-container">
        <div
          className="flex py-2"
          style={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <p className="mini-title">Notifications</p>
          <Dropdown overlay={menu}>
            <i
              className="icon-more"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          </Dropdown>
        </div>
        <div className="scroll-section">
          {props.notifications.length > 0 ? (
            <>
              {todaysNotifs.length > 0 && (
                <>
                  <p className="mini-sub-title">Today</p>
                  {renderListView(todaysNotifs)}
                </>
              )}
              {earlierNotifs.length > 0 && (
                <>
                  <p className="mini-sub-title">Earlier</p>
                  {renderListView(earlierNotifs)}
                </>
              )}
              <div style={{ display: "flex" }}>
                <Link
                  to={`/notifications/`}
                  className="block md:inline-block text-white md:mt-0 uppercase hover:text-white mt-2"
                  onClick={() => {
                    console.log("clicked");
                    props.hide();
                  }}
                >
                  <label style={{ color: "#000", fontWeight: 600 }}>
                    View All
                  </label>
                </Link>
              </div>
            </>
          ) : (
            <p
              style={{ textAlign: "center", fontSize: "16px", padding: "16px" }}
            >
              No unread notifications
            </p>
          )}
        </div>
      </div>
      <style>
        {` 
          .ant-popover-content {
            cursor:default;
          }
          .mini-title{
            font-size:20px;
            font-weight:bold;
          }
          .mini-sub-title {
            font-size:16px;
            font-weight:bold;
          }
          .notification-mini-container {
              max-height:100%;
              width:500px;
              padding: 20px;
          }
          .notif-list-item1 {
              padding: 10px 5px;
              .ant-avatar-string{
                    transform: scale(1.5) translate3d(-9px, 6px, 10px) !important;
              }
            
          }
					.scroll-section {
						max-height: 320px;
						overflow: auto;
					}
					.scroll-section::-webkit-scrollbar {
						width: 5px;
					}
					.scroll-section::-webkit-scrollbar-thumb {
						background: #d8d8d8;
					}
          .notif-text-small{
              font-size:14px;
              color:#888888
          }
          .notif-text{
            font-size:16px;
            color:#333333
          }
          .section-header {
            font-size:16px;
            color:#333333;
            font-weight:bold;
          }
          @media only screen and (max-width: 768px) {
            .notification-mini-container {
              width: 100vw;
              height:100vh;
            }
            .scroll-section {
              max-height: 84vh;
              overflow: auto;
            }
          }    
        `}
      </style>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  notifications: state.notification.notifications,
});

export default connect(mapStateToProps, {
  getAllNotifications,
  updateAllNotifications,
})(NotificationMiniView);
